import BoldSmallText from '../BoldSmallText';
import InformationBanner from '../InformationBanner';

interface IProps {
  isVisible: boolean;
  onDismiss: () => void;
  isAllCondition?: boolean;
}
const ConditionBanner = ({ isAllCondition, isVisible, onDismiss }: IProps) => {
  return (
    <InformationBanner isVisible={isVisible} onDismiss={onDismiss}>
      {isAllCondition ? (
        <BoldSmallText>
          This rule shows on <span className="text--underline">All Products</span> when no item condition exists. Try adding some
          customized conditions.
        </BoldSmallText>
      ) : (
        <BoldSmallText>This rule only shows when following conditions match</BoldSmallText>
      )}
    </InformationBanner>
  );
};

export default ConditionBanner;
